/**
 * @file 表单校验规则
 * @author svon.me@gmail.com
 * @description https://github.com/yiminghe/async-validator
 */

import * as _ from "lodash-es";
import {i18n} from "@/locales";

export const required = function (message) {
  return [{
    message, required: true, trigger: ["blur", "change"], validator (rule, value) {
      if (_.isNil(value)) {
        return Promise.reject(message || "数据不能为空!");
      }
      if (Array.isArray(value) && value.length < 1) {
        return Promise.reject(message || i18n("common.pleaseSelect"));
      }
      return Promise.resolve();
    },
  }];
}

export const text = function (message = i18n("common.pleaseEnter"), required = true, transform) {
  return [{
    required, message, trigger: ["blur", "change"], transform: transform || toString
  }];
}

export const integer = function (message = i18n("common.pleaseEnter"), required = true, transform) {
  return [{
    type: "number", required, message, trigger: ["blur", "change"], transform: transform || toInteger
  }];
}

export const number = function (message = i18n("common.pleaseEnter"), required = true, transform) {
  return [{
    type: "number", required, message, trigger: ["blur", "change"], transform: transform || toNumber
  }];
}

export const link = function (message = `${i18n("common.pleaseEnter")} link`, required = true, transform) {
  return [{
    required, message, type: "url", trigger: ["blur", "change"], transform: transform || toString
  }];
}

export const email = function (message = `${i18n("common.pleaseEnter")} email`, required = true, transform) {
  return [{
    required, message, type: "email", trigger: ["blur", "change"], transform: transform || toString
  }];
}

export const passwordDiff = function (message = `${i18n("common.pleaseEnter")} email`, password) {
  return [{
    required: true, message, trigger: ["blur", "change"], transform: toString, validator (rule, value) {
      if (value && value === password) {
        return Promise.resolve();
      }
      return Promise.reject(message);
    },
  }];
}

export const date = function (message = i18n("common.pleaseEnter"), required = true, transform) {
  return [{
    required, message, type: "date", trigger: ["blur", "change"], transform: transform || toDate,
  }];
}

export const array = function (message = i18n("common.pleaseSelect"), required = true, transform) {
  return [{
    required, message, type: "array", trigger: ["blur", "change"], min: 1, transform, validator (rule, value) {
      if (value && Array.isArray(value) && value.length > 0) {
        return Promise.resolve();
      }
      return Promise.reject(message);
    },
  }];
}

export const toString = function (value) {
  if (value || value === 0) {
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
  }
  return value;
};

export const toNumber = function (value) {
  if (value && /^\d{1,}(\.\d{1,})?$/i.test(value)) {
    return Number(value);
  }
  return value;
}

export const toInteger = function (value) {
  if (value && /^\d+$/i.test(value)) {
    return Number(value);
  }
};

export const toDate = function (value) {
  if (value) {
    return new Date(value);
  }
  return null;
}


export const concat = function (...args) {
  return _.flattenDeep(args);
}